export const SHIFTS_SECTIONS = [
    { id: 'calendar', tabLabel: 'Kalendář', icon: '📅' },
    { id: 'vyjezdy', tabLabel: 'Výjezdy', icon: '🚌', manageOnly: true },
    { id: 'overview', tabLabel: 'Přehled hodin', icon: '📊' },
    { id: 'vacation', tabLabel: 'Dovolená', icon: '🏖️', adminOnly: true },
    { id: 'attendance', tabLabel: 'Docházka', icon: '⏰' },
    { id: 'payroll', tabLabel: 'Výplata', icon: '💰', adminOnly: true },
    { id: 'absent-stores', tabLabel: 'Není v práci', icon: '🚨', adminOnly: true },
    { id: 'attendance-log', tabLabel: 'Docházka log', icon: '📋', adminOnly: true },
];
